import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { guides } from '../data/admissionData';
import { usePageMeta } from '../hooks/usePageMeta';
import '../styles/Home.css';

const Home = () => {
  const [ready, setReady] = useState(false);

  usePageMeta({
    title: null,
    description:
      '미라이쥬쿠 — 일본 대학 입시 요강·EJU·일반입시·국비 루트를 단순하고 명확하게.',
    path: '/',
  });

  useEffect(() => {
    const id = requestAnimationFrame(() => setReady(true));
    return () => cancelAnimationFrame(id);
  }, []);

  return (
    <div className={`apple-home ${ready ? 'is-ready' : ''}`}>
      <section className="apple-hero">
        <p className="apple-hero-brand">未来塾 Miraijuku</p>
        <h1 className="apple-hero-title">
          일본 입시 요강.
          <br />
          더 단순하게.
        </h1>
        <p className="apple-hero-sub">
          EJU · 일반입시 · 국비 루트를 한곳에서. 필요한 정보만, 명확하게.
        </p>
        <div className="apple-hero-cta">
          <Link to="/finder" className="apple-btn apple-btn-primary">루트 찾기</Link>
          <Link to="/resources" className="apple-link">공식 자료</Link>
        </div>
      </section>

      <section className="apple-band apple-band-alt">
        <div className="apple-band-inner apple-split">
          <div>
            <h2>한 번에 하나씩.</h2>
            <p>
              복잡한 전형을 세 단계로 나눕니다. 가이드로 이해하고, 조건으로 좁히고,
              요강 원문으로 확정하세요.
            </p>
          </div>
          <ol className="apple-steps">
            <li>
              <strong>이해</strong>
              <span>EJU와 일반입시, 국비의 구조</span>
            </li>
            <li>
              <strong>선택</strong>
              <span>전공·단계에 맞는 루트 필터</span>
            </li>
            <li>
              <strong>확인</strong>
              <span>모집요항 원문으로 최종 대조</span>
            </li>
          </ol>
        </div>
      </section>

      <section className="apple-band">
        <div className="apple-band-inner">
          <h2>가이드</h2>
          <p className="apple-band-lede">읽기 쉬운 해설부터. 본문은 순차 공개합니다.</p>
          <ul className="apple-rail">
            {guides.slice(0, 3).map((guide) => (
              <li key={guide.id}>
                <Link to={`/guides/${guide.id}`} className="apple-rail-item">
                  <span className="apple-rail-meta">{guide.category}</span>
                  <span className="apple-rail-title">{guide.title}</span>
                  <span className="apple-rail-more">더 알아보기</span>
                </Link>
              </li>
            ))}
          </ul>
          <div className="apple-band-footer">
            <Link to="/checklist" className="apple-link">요강 체크리스트</Link>
            {' · '}
            <Link to="/guides" className="apple-link">모든 가이드</Link>
          </div>
        </div>
      </section>

      <section className="apple-band apple-band-dark">
        <div className="apple-band-inner apple-center">
          <h2>내 조건으로 시작하세요.</h2>
          <p>전형과 전공을 고르면, 맞춰 볼 경로와 다음 할 일을 보여 줍니다.</p>
          <Link to="/finder" className="apple-btn apple-btn-primary">루트 파인더</Link>
        </div>
      </section>

      <section className="apple-band apple-band-alt">
        <div className="apple-band-inner apple-center">
          <h2>선택이 필요할 때.</h2>
          <p>
            도구로 정리한 뒤, 90분 루트 세션이나 연간 시즌패스가 필요하면 신청할 수 있습니다.
          </p>
          <div className="apple-hero-cta" style={{ justifyContent: 'center' }}>
            <Link to="/consulting" className="apple-btn apple-btn-primary">
              컨설팅
            </Link>
            <Link to="/pass" className="apple-link">
              시즌패스
            </Link>
          </div>
        </div>
      </section>

      <section className="apple-band">
        <div className="apple-band-inner apple-about-lite">
          <div>
            <h2>왜 미라이쥬쿠인가.</h2>
            <p>
              국비 · 이공 · 일반입시 의대까지. 같은 길을 걸어 본 시선으로
              정보가 끊기는 지점만 골라 정리합니다.
            </p>
            <Link to="/about" className="apple-link">소개</Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
